import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { remintSession } from "../lib/auth";
import { navigate } from "../lib/router";
import { MapView } from "../MapView";

export function MapRoute() {
  const [status, setStatus] = useState<"checking" | "ok" | "denied">("checking");

  useEffect(() => {
    let cancelled = false;
    // Cheap authenticated probe. Deliberately not `head: true`: a HEAD
    // response never carries a body, so an expired-JWT error would have no
    // message to match against, and the remint trigger below could never
    // fire. `count` on the readable response is the strictly better signal
    // for "is this session actually live" - it also catches a revoked share
    // (RLS still accepts the still-valid JWT, but the row no longer
    // matches, so count is 0), which cookie presence alone cannot: fail
    // closed per CLAUDE.md.
    async function probe() {
      return await supabase()
        .from("share")
        .select("id", { count: "exact" });
    }
    async function check() {
      let result = await probe();
      if (cancelled) return;
      if (result.error) {
        const ok = await remintSession();
        if (cancelled) return;
        if (!ok) { navigate("/expired", true); return; }
        result = await probe();
        if (cancelled) return;
      }
      if (result.error || (result.count ?? 0) === 0) {
        navigate("/expired", true);
        return;
      }
      setStatus("ok");
    }
    check();
    return () => { cancelled = true; };
  }, []);

  if (status === "checking") return null;
  return <MapView />;
}
